var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFE3E9",
    d: "M.687 8.368L9 .524l8.289 7.844v8.804H.687z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18c.305 0 .568-.108.791-.325.223-.217.334-.484.334-.8V8.394a.174.174 0 00-.018-.08 1.236 1.236 0 00-.07-.28.843.843 0 00-.14-.247l-.018-.017a.698.698 0 00-.088-.106l-.105-.105L10.23.475C9.913.158 9.515 0 9.034 0c-.48 0-.879.158-1.195.475L.51 7.505a3.646 3.646 0 00-.317.388.934.934 0 00-.193.562v8.42c0 .316.111.583.334.8.223.217.486.325.791.325h15.75zm-4.395-5.924L10.09 9.95a1.826 1.826 0 00-1.134-.395 1.786 1.786 0 00-1.169.413l-2.215 2.039-4.254-3.762.475-.457h.035l6.803-6.521a.801.801 0 01.193-.115.547.547 0 01.211-.044c.07 0 .14.015.211.044.07.03.135.068.193.115l6.346 6.064h-.017l.966.967-4.254 3.78zM1.125 16.102V9.58l3.621 3.182-3.621 3.34zm15.75-.053l-3.568-3.2 3.568-3.163v6.363zm-.756.826H1.934l3.972-3.639a.514.514 0 01.053-.044.174.174 0 00.053-.061l.009-.009.008-.009 2.479-2.285a.755.755 0 01.202-.114.655.655 0 01.237-.044c.082 0 .161.012.238.035a.437.437 0 01.184.106l6.75 6.064z",
    fill: "#333647",
    fillRule: "nonzero"
  }))));
};

export default SvgMail;